import { useMutation } from '@tanstack/react-query';

import axiosInstance from 'src/utils/axios';

interface CreateSessionRequest {
  user_id: string;
  tenant_id: string;
}

const createSession = async (data: CreateSessionRequest): Promise<string> => {
  const response = await axiosInstance.post('/session', data);
  return response.data;
};

export function useCreateSession() {
  const { mutate } = useMutation({
    mutationFn: createSession,
    onSuccess: (sessionId) => {
      localStorage.setItem('sessionId', sessionId);
    },
  });

  return mutate;
}